<template>
  <el-row type="flex" class="app-layout orver-hidden-x slow-system-call-list">
    <el-form
      class="padding-20"
      :style="{
        'border-bottom': '1px solid #e5e5e5',
        'text-align': 'left',
      }"
      ref="queryForm"
      :model="formQuery"
      size="small"
      @submit="searchTableData(1)"
      inline
      @keyup.enter.native="searchTableData(1)"
    >
        <el-form-item label prop="serverName" label-width="0">
          <el-input
            v-model="formQuery.serverName"
            placeholder="请输入服务名称"
            clearable
            @change="searchTableData(1)"
          ></el-input>
        </el-form-item>

        <el-form-item label prop="traceId" label-width="0">
          <el-input
            v-model="formQuery.traceId"
            placeholder="请输入跟踪ID"
            clearable
            @change="searchTableData(1)"
          ></el-input>
        </el-form-item>

        <el-form-item label prop="visitorId" label-width="0">
          <el-input
            v-model="formQuery.visitorId"
            placeholder="请输入用户ID"
            clearable
            @change="searchTableData(1)"
          ></el-input>
        </el-form-item>

        <el-form-item label prop="uri" label-width="0">
          <el-input
            v-model="formQuery.uri"
            placeholder="请输入接口地址"
            clearable
            @change="searchTableData(1)"
          ></el-input>
        </el-form-item>

        <el-form-item label prop="apiSuccess" label-width="0">
          <el-select
            v-model="formQuery.apiSuccess"
            @change="searchTableData(1)"
            clearable
            placeholder="请选择状态">
            <el-option :value="true" label="成功"></el-option>
            <el-option :value="false" label="失败"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label>
          <el-date-picker
            v-model="formQuery.range"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            unlink-panels
            :clearable="false"
            @change="searchTableData(1)"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
            <el-button
            icon="el-icon-search"
            type="primary"
            :loading="tableLoading"
            size="small"
            @click="searchTableData(1)"
          >查询</el-button>
        </el-form-item>

        <el-form-item :style="{'float': 'right'}">
           <el-button size="small" :loading="tableLoading" @click="queryReset()">重置</el-button>
          <column-switch
            class="margin-left-10"
            name="SYSTEM_SLOW_CALL_LIST"
            :columns.sync="columns"
          >
            <el-button size="small" type="primary">列设置</el-button>
          </column-switch>
        </el-form-item>

    </el-form>
    <div class="flex-table">
      <el-table
        height="100%"
        :key="columns.length"
        :data="tableData"
        v-loading="tableLoading"
        stripe
        style="width: 100%"
      >
        <template v-for="(item, index) in columnsList">
          <el-table-column
            v-if="columns[item.label]"
            :width="item.width"
            :min-width="item.minWidth"
            :label="item.label"
            :prop="item.prop"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
          >
            <template #default="{ row }" v-if="item.tmpl">
              <template v-if="item.label === '状态'">
                <el-tag :type="row.apiSuccess ? 'success' : 'danger'">
                  {{
                  row.apiSuccess ? "成功" : "失败"
                  }}
                </el-tag>
              </template>
              <template v-if="item.label === '异常'">
                <el-link :type="row.apiSuccess ? 'success' : 'danger'">【{{ row.apiCode }}】</el-link>
                {{ row.apiMessage }}
              </template>
              <template v-if="item.label === '跟踪ID'">
                <el-link
                  type="primary"
                  :underline="false"
                  @click="handlePageToSearch(row)"
                >{{ row.traceId }}</el-link>
              </template>
              <template v-if="item.prop === 'source'">{{ renderSource(row.source) }}</template>
            </template>
          </el-table-column>
          <template v-else></template>
        </template>
      </el-table>
    </div>
    <el-row class="padding-20">
      <el-col align="right">
        <el-pagination
          class="analyze-users-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="formQuery.pageNum"
          :page-sizes="[20, 50, 100, 200, 300, 400]"
          :page-size="formQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="formQuery.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import { mapGetters } from 'vuex';
import { queryApiRequest } from '@/api/tracking';
import { parseTime } from '@/utils';
import Moment from 'moment';

export default {
  name: 'TrackingSlowSystemCallList',
  data() {
    return {
      formQuery: {
        traceId: '',
        serverName: '',
        uri: '',
        range: [],
        pageNum: 1,
        pageSize: 20,
        apiSuccess: '',
      },
      queryApiStat: {
        costAvg: 0,
        successScale: 0,
        count: 0,
        analyzeTimeTo: parseTime(new Date().getTime(), 'yyyy-MM-dd'),
      },
      tableLoading: false,
      tableData: [],
      columnsList: [
        {
          label: '时间',
          minWidth: 160,
          prop: 'requestTime',
        },
        {
          label: '接口地址',
          prop: 'uri',
          minWidth: 160,
        },
        {
          label: '请求方法',
          prop: 'httpMethod',
        },
        {
          label: '跟踪ID',
          prop: 'traceId',
          sortable: true,
          tmpl: true,
          minWidth: 160,
        },
        {
          label: '响应时间(ms)',
          prop: 'cost',
          minWidth: 140,
          sortable: true,
        },
        {
          label: '来源',
          prop: 'source',
          tmpl: true,
        },
        {
          label: '服务名称',
          prop: 'serverName',
          minWidth: 120,
        },
        {
          label: '应用环境',
          prop: 'env',
        },
        {
          label: '用户ID',
          prop: 'visitorId',
        },
        {
          label: '状态',
          tmpl: true,
          minWidth: 100,
        },
        {
          label: '异常',
          tmpl: true,
          minWidth: 320,
        },
      ],
      columns: {
        时间: true,
        接口地址: true,
        请求方法: true,
        跟踪ID: true,
        '响应时间(ms)': true,
        来源: true,
        用户ID: true,
        状态: true,
        异常: true,
        服务名称: true,
        应用环境: true,
      },
    };
  },
  mounted() {
    const { time, uri = '' } = this.$route.query;
    const today = new Moment().format('YYYY-MM-DD');
    this.formQuery.range = [
      new Date(`${time || today} 00:00:00`),
      new Date(`${time || today} 23:59:59`),
    ];

    this.formQuery.uri = uri;

    this.searchTableData();
  },
  computed: {
    ...mapGetters('app', ['env', 'source', 'sourceList']),
  },
  watch: {
    source: {
      handler() {
        this.searchTableData();
      },
    },
    env: {
      handler() {
        this.searchTableData();
      },
    },
  },
  methods: {
    renderSource(val) {
      return this.sourceList?.filter((item) => item.key === val)[0]?.name;
    },
    handlePageToSearch({ traceId, requestTime }) {
      const time = requestTime.split(' ')[0];
      window.open(`${window.location.origin}/#/log-analysis/search?traceId=${traceId}&time=${new Date(`${time} 00:00:00`).getTime()},${new Date(`${time} 23:59:59`).getTime()}`);
    },
    // 重置方法
    queryReset() {
      const today = new Moment().format('YYYY/MM/DD');
      this.formQuery = {
        traceId: '',
        serverName: '',
        pageNum: 1,
        pageSize: 20,
        uri: '',
        apiSuccess: '',
        range: [new Date(`${today} 00:00:00`), new Date(`${today} 23:59:59`)],
      };
      this.searchTableData(1);
    },
    async searchTableData(currentPageNum) {
      if (currentPageNum) {
        this.queryApiStat.pageSize = currentPageNum;
      }
      try {
        this.tableLoading = true;

        const {
          traceId,
          pageNum,
          pageSize,
          serverName,
          visitorId,
          range,
          uri,
          apiSuccess,
        } = this.formQuery;

        const params = {
          traceId,
          visitorId,
          serverName,
          uri,
          pageNum: currentPageNum || pageNum,
          pageSize,
          apiSuccess,
        };

        if (range && range.length > 0) {
          params.requestTimeFrom = new Moment(range[0]).format(
            'YYYY-MM-DD HH:mm:ss',
          );
          params.requestTimeTo = new Moment(range[1]).format(
            'YYYY-MM-DD HH:mm:ss',
          );
        }

        const {
          data: { list, total },
        } = await queryApiRequest(params);
        this.formQuery.total = total;
        this.tableData.splice(0, this.tableData.length, ...list);
      } finally {
        this.tableLoading = false;
      }
    },
    handleSizeChange(size) {
      this.formQuery.pageSize = size;
      this.formQuery.pageNum = 1;
      this.searchTableData();
    },
    handleCurrentChange(num) {
      this.formQuery.pageNum = num;
      this.searchTableData();
    },
  },
};
</script>
<style lang="scss">
.el-picker-panel__footer .el-picker-panel__link-btn.el-button--text {
  display: none;
}
</style>
<style lang="scss" scoped>
.app-layout {
  height: calc(100vh - 100px);
  flex-direction: column;
  .flex-table {
    flex: 1;
  }
}
</style>
